import React from 'react';
import '../css/Footer.css';

const Footer = () => {
    return (
        <footer id="site-footer" className="clearfix">
            <div id="footer-wrapper" className="center-container">
                <div id="footer-logos">
                    <div className="foot-main-logo">
                        <a href="/">
                            <img alt="Colombo Dockyard PLC" src="/wp-content/themes/cdl/images/CDL_footer.png" />
                        </a>
                    </div>
                    <div className="partners">
                        <img width="113" height="72" alt="Colombo Dockyard PLC" src="/wp-content/uploads/2023/08/LRQA-UKAS.jpg" />
                    </div>
                </div>

                <nav className="footer-menu">
                    <div>
                        <h2>Navigation</h2>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="/our-odyssey.html">About</a></li>
                            <li><a href="/agents.html">Agents</a></li>
                            <li><a href="/contact-us.html">Contact Us</a></li>
                        </ul>
                    </div>
                    <div>
                        <h2>Quick Links</h2>
                        <ul>
                            <li><a href="/main-news.html">News</a></li>
                            <li><a href="/privacy-policy.html">Privacy Policy</a></li>
                            <li><a href="/HelpFAQ.html">Help / FAQ</a></li>
                            <li><a href="/tenders.html">Tenders</a></li>
                        </ul>
                    </div>
                </nav>

                <div id="news-letter">
                    <h2>NewsLetter</h2>
                    <form className="form-newsltter">
                        <input 
                            type="text" 
                            name="email" 
                            className="newstxt" 
                            placeholder="Enter Your Email Address" 
                        />
                        <input 
                            type="image" 
                            src="/wp-content/themes/cdl/images/nwsltr-arrow.png" 
                            height="21" 
                            width="26" 
                            className="newsbtn" 
                            alt="Subscribe" 
                        />
                    </form>

                    <div className="cdl-pdf">
                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2022/03/CDPLC_at_TRINCO_-_RRARS.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2020/07/onomichi.png" width="20" height="50" alt="Onomichi" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2022/03/CDPLC_at_TRINCO_-_RRARS.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD TRINCO<br /> DOCKYARD BROCHURE</h3>
                                </a>
                            </div>
                        </div>

                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2022/03/CDPLC_at_HIP_-_RRARS_CP.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2020/07/onomichi.png" width="20" height="50" alt="HIP" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2022/03/CDPLC_at_HIP_-_RRARS_CP.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD HIP<br /> DOCKYARD BROCHURE</h3>
                                </a>
                            </div>
                        </div>

                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2024/04/Afloat-Repair-Brochure-March-2024.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2019/05/cscimg3.png" width="20" height="50" alt="Afloat" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2024/04/Afloat-Repair-Brochure-March-2024.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD OUR RAPID RESPONSE AFLOAT REPAIRS LEAFLET</h3>
                                </a>
                            </div>
                        </div>

                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2024/04/Colombo Dockyard Company Profile.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2021/09/cdl-pdf-img.png" width="20" height="50" alt="Profile" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2024/04/Colombo Dockyard Company Profile.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD OUR LATEST COLOMBO DOCKYARD PROFILE</h3>
                                </a>
                            </div>
                        </div>

                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2021/11/CDPLC-Installed-Ballast-Water-Management-SYstems_new.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2020/07/onomichi.png" width="20" height="50" alt="Ballast Water" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2021/11/CDPLC-Installed-Ballast-Water-Management-SYstems_new.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD OUR BALLAST WATER MANAGEMENT SYSTEM LEAFLET</h3>
                                </a>
                            </div>
                        </div>

                        <div className="cdl-pdf-item">
                            <div className="cdl-pdf-img">
                                <a href="/wp-content/uploads/2024/08/ColDock_Whiz_50th_Anniversary_Edition.pdf" target="_blank">
                                    <img src="/wp-content/uploads/2022/11/Coldock-Whiz-November-2022.png" width="20" height="50" alt="Whiz" />
                                </a>
                            </div>
                            <div className="cdl-pdf-txt">
                                <a href="/wp-content/uploads/2024/08/ColDock_Whiz_50th_Anniversary_Edition.pdf" target="_blank">
                                    <h3 className="dwnload-icon">DOWNLOAD COLDOCK WHIZ</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="footer-bottom">
                <div className="site-info">
                    &copy; 2025. Colombo Dockyard All Rights Reserved | 
                    <a href="https://dockyardsoftware.com/" target="_blank" rel="noopener noreferrer"> -Dockyard Software-</a> | 
                    <a href="https://dockyardsoftware.com/Pages/contact/" target="_blank" rel="noopener noreferrer"> Feedback.</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
